<template>
  <div class="">
    <CwePageHeader :authenticationRequired="true" />
    <div class="shared-page">
      <div class="centeredContentBox grant-permissions">
        <h1 class="header-left" role="heading">
          {{ $t("grant_permissions_title", [provider]) }}
        </h1>
        <p class="grant-permissions-body">
          {{ $t("grant_permissions_body", [provider]) }}
        </p>
        <div v-if="pageErrorMessage">
          <p class="alertBox textLarge bottomSpaceDouble">
            {{ pageErrorMessage }}
          </p>
        </div>
        <div class="button-section-right">
          <button class="button-right" 
                  type="button" 
                  @click="submitHandler" 
                  data-testid="confirmButton">
              {{ $t('confirm_acceptance') }}
          </button>
          <button class="button-right go-back"
                  type="button" 
                  data-testid="cancelButton"
                  @click="cancelHandler">
              {{ $t('cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { store } from '../store'
import CwePageHeader from '../components/CwePageHeader.vue';
import { grantLoginPermissions } from '../api/endpoints/authConfig';
import { handleApiRequest } from '../api/handleApiRequest';
import { i18n } from '@/plugins/i18n'
import FixProxyUrl from '../services/FixProxyUrl';
import { enterPage } from '../services/Readiness';
const $t = i18n.global.t;

export default defineComponent({
  name: 'GrantLoginPermissionsPage',
  components: { CwePageHeader },
  props: {
    provider: {
      type: String,
      required: true
    },
    appRedirect: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      pageErrorMessage: ''
    };
  },
  mounted() {
    enterPage('grant-login-permissions').ready();
  },
  methods: {
    async cancelHandler() {
      window.location.href = FixProxyUrl('/logout?errorKey=access_denied');
    },
    async submitHandler() {
      store.state.loadingCount++;

      const result = await handleApiRequest(() =>
            grantLoginPermissions({
              identityProviderKey: this.provider,
              grantPermission: true
            })
      );

	  if (!result.errors || !result.errors.length) {
          if (this.appRedirect !== '')
            this.$router.push({ name: 'Dashboard', query: {app: this.appRedirect} });
          else
            this.$router.push({ name: 'Dashboard' });
      } else {
        if(result.errors[0].localizedName) 
          this.pageErrorMessage = result.errors[0].localizedName;
        else 
          this.pageErrorMessage = $t(result.errors[0].key);
      }
      store.state.loadingCount--;
    }
  }
});
</script>

<style lang="scss" scoped>

.grant-permissions {
  display: flex;
  flex-direction: column;
}

.grant-permissions-body {
  padding-top: $standard_space * 2;
}

.button-section {
  padding-top: $standard_space * 2;
}
</style>